import React, { useState } from 'react';
import styled from '@emotion/styled';
import { SeedlangIconWithCircle } from '@seedlang/icons';
import Modal from 'components/modal';
import ReviewExplainer from 'components/review/review_explainer';
import { flexCenter } from '@seedlang/style_mixins';
import { Theme } from '@seedlang/constants';

export const HelpButton = styled.button`
  border: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  cursor: pointer;
  ${flexCenter()}
  background: #A9A9A9;
  color: #FFF;
  font-weight: bold;
  font-size: 12px;
`;

export const AbsoluteContainer = styled.div`
  position: absolute;
  inset: 0;
  width: fit-content;
  height: fit-content;
  z-index: 2;
  ${flexCenter()}
  gap: 5px;
`;

export const SeedlangIconWrapper = styled.div`
  background: ${Theme.blue};
  border-radius: 0 0 12px 0;
  padding: 10px;
  cursor: pointer;
`;

const SeedlangExplainer = () => {
  const [showHelpModal, setShowHelpModal] = useState(false);

  return (
    <>
      {showHelpModal && (
        <Modal onCloseModal={() => setShowHelpModal(false)} iconFill='#000'>
          <ReviewExplainer />
        </Modal>
      )}
      <AbsoluteContainer>
        <SeedlangIconWrapper onClick={() => setShowHelpModal(true)} aria-label='Seedlang Logo'>
          <SeedlangIconWithCircle width='20px' height='20px' />
        </SeedlangIconWrapper>
        <HelpButton onClick={() => setShowHelpModal(true)} title='Help'>?</HelpButton>
      </AbsoluteContainer>
    </>
  );
};

export default SeedlangExplainer;